import { render, staticRenderFns } from "./DonationPayment.vue?vue&type=template&id=2f045bf8&"
import script from "./DonationPayment.vue?vue&type=script&lang=js&"
export * from "./DonationPayment.vue?vue&type=script&lang=js&"
import style0 from "./DonationPayment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports